import { routeFactory } from "@/RouteFactory";
import {
  ActionMenu,
  ActionMenuItem,
  SecondaryButton,
  stenaBusinessAgreement,
  stenaFilePdfLabel,
  stenaPen,
} from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { HeaderAgreementPickerModal } from "../head-agreement-picker/HeadAgreementPickerModal";

type NoExistingHeadAgreementActionButtonsProps = {
  parentCustomerId: string;
};

export const NoExistingHeadAgreementActionButtons = ({
  parentCustomerId,
}: NoExistingHeadAgreementActionButtonsProps) => {
  const { customerId } = useParams() as { customerId: string };
  const navigate = useNavigate();

  const [reportType, setReportType] = useState("");
  const [isHeaderAgreementPickerOpen, setIsHeaderAgreementPickerOpen] =
    useState(false);

  return (
    <>
      <Popover
        placement={"left"}
        disablePadding
        trigger={"click"}
        appendTo={document.body}
        renderTrigger={(props) => (
          <SecondaryButton label="Actions" leftIcon={stenaPen} {...props} />
        )}
      >
        <ActionMenu>
          <ActionMenuItem
            label={"New agreement"}
            leftIcon={stenaBusinessAgreement}
            onClick={() =>
              navigate(
                routeFactory.productAndPrice.headAgreement.createHeadAgreement({
                  customerId,
                })
              )
            }
          />
          <ActionMenuItem
            label={"Create offer"}
            leftIcon={stenaFilePdfLabel}
            onClick={() => {
              setReportType("offer");
              setIsHeaderAgreementPickerOpen(true);
            }}
          />
          <ActionMenuItem
            label={"Create confirmation"}
            leftIcon={stenaFilePdfLabel}
            onClick={() => {
              setReportType("confirmation");
              setIsHeaderAgreementPickerOpen(true);
            }}
          />
        </ActionMenu>
      </Popover>
      {isHeaderAgreementPickerOpen && (
        <HeaderAgreementPickerModal
          onClose={() => setIsHeaderAgreementPickerOpen(false)}
          parentCustomerId={parentCustomerId}
          reportType={reportType}
        />
      )}
    </>
  );
};
